import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ComponentResponse } from '~/models/Commons ';
import { RootState } from '~/store/index';

interface State {
    components: ComponentResponse[];
     authenticated: boolean;
}

const initialState: State = {
    components: [],
    authenticated:false
};

const CloudEnvironmentSlice = createSlice({
    name: 'components',
    initialState,
    reducers: {
        SET_COMPONENTS(state, { payload }: PayloadAction<ComponentResponse[]>) {
            state.components = payload;
        },
            DELETE_COMPONENTS_BYID(state, { payload }: PayloadAction<number>) {
            if (!Array.isArray(state.components)) {
                state.components = [];
            }

            state.components = state.components.map(item =>
                item.id !== payload ? item : { ...item, active: false }
            );
        },

        ADD_COMPONENTS(state, { payload }: PayloadAction<ComponentResponse>) {
            const newScripts = [...state.components, payload];
            state.components = newScripts;
        },
        PATCH_COMPONENTS(state, { payload }: PayloadAction<ComponentResponse>) {
            const newCloudEnvironment = [...state.components];
            const findInd = newCloudEnvironment.findIndex(({ id }) => id === payload.id);
            if (findInd < 0) return;

            newCloudEnvironment[findInd] = { ...payload };
            state.components = newCloudEnvironment;
        },
         SET_AUTHENTICATED(state, { payload }: PayloadAction<boolean>) {
            state.authenticated = payload;
        },
    },
});

export const selectComponents = (state: RootState) => state.script;

export const { SET_COMPONENTS, DELETE_COMPONENTS_BYID, ADD_COMPONENTS, PATCH_COMPONENTS,SET_AUTHENTICATED } =
    CloudEnvironmentSlice.actions;

export default CloudEnvironmentSlice.reducer;
